export function getTimeDate(create_time){
    const timeDate = new Date(create_time)
    const year = timeDate.getFullYear();
    const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
    const day = timeDate.getDate().toString().padStart(2, '0');
    const hours = timeDate.getHours().toString().padStart(2, '0');
    const minutes = timeDate.getMinutes().toString().padStart(2, '0');
    const seconds = timeDate.getSeconds().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate
}

export function timeDifference(updateTime) {
    const currentTime = new Date();
    const updateDateTime = new Date(updateTime);
    const timeDiff = currentTime - updateDateTime;

    if(timeDiff > 7 * 24 * 60 * 60 * 1000){
      return updateTime;
    }else if (timeDiff <= 7 * 24 * 60 * 60 * 1000) {
      const days = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
      return `${days} 天前`;
    } else if (timeDiff >= 5 * 60 * 60 * 1000) {
      const hours = Math.floor(timeDiff / (60 * 60 * 1000));
      return `${hours} 小时前`;
    } else if (timeDiff >= 60 * 60 * 1000) {
      const minutes = Math.floor(timeDiff / (60 * 1000));
      return `${minutes} 分钟前`;
    } else {
      return '刚刚';
    }
  }